import React, { Component } from 'react'
import {InfoCreditor} from '../../calculator/components/partials'

export default class InfoCreditorContainer extends Component{


  render(){
    return(
      <div className="calculator-wrapper">
        <InfoCreditor/>
      </div>

    )
  }

}


// WEBPACK FOOTER //
// ./src/features/pages/containers/InfoCreditorContainer.js